import { useQuery } from '@tanstack/react-query';
import { supabase } from '../../api';

const getOrder = async id => {
  const { data: orderId, error: orderError } = await supabase
    .from('order_items')
    .select('*, orders(*), product(*)')
    .eq('order_id', id)
    .single();

  if (orderError) {
    throw new Error(`Error fetching orders: ${orderError.message}`);
  }

  return orderId;
};

export default function useGetOrderItemsByOrderId(id) {
  return useQuery({
    queryKey: ['useGetOrderItemsByOrderId', id],
    queryFn: () => getOrder(id),
    staleTime: 0,
    enabled: !!id,
  });
}
